/* eslint-disable
    eqeqeq,
    no-empty,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__
 * DS104: Avoid inline assignments
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';
import { siteDomain } from '@trello/config';
import { Helpers as AttachmentHelpers } from 'app/scripts/views/attachment/Helpers';
import { AttachmentViewer } from 'app/scripts/views/internal/AttachmentViewer';
import { Auth } from 'app/scripts/db/Auth';
import {
  getPermLevelIconClassForBoard,
  getPermLevelAltTextForBoard,
} from 'app/scripts/views/internal/BoardDisplayHelpers';
import { isHighDPI } from '@trello/browser';
// eslint-disable-next-line no-restricted-imports
import { Controller } from 'app/scripts/controller';
import { Dates } from 'app/scripts/lib/dates';
import { EntityDisplay } from 'app/scripts/lib/entity-display';
import { hasSelection } from 'app/scripts/lib/util/selection/has-selection';
import { KnownServices } from 'app/scripts/db/known-services';
import { ModelCache } from 'app/scripts/db/model-cache';
import { PopOver } from 'app/scripts/views/lib/PopOver';
import React from 'react';
import ReactDOM from '@trello/react-dom-wrapper';
import { ReactionPiles } from 'app/scripts/views/reactions/ReactionPiles';
import { TFM } from 'app/scripts/lib/markdown/Tfm';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';
import { View } from 'app/scripts/views/internal/view';
import _ from 'underscore';
import { friendlyLinks } from 'app/scripts/views/internal/friendlyLinks';
import moment from 'moment';
import { templates } from 'app/scripts/views/internal/templates';
import { Analytics } from '@trello/atlassian-analytics';
import { l } from 'app/scripts/lib/localize';
import actionTemplate from 'app/scripts/views/templates/action';
import Promise from 'bluebird';
import { pluginRunner } from 'app/scripts/views/internal/plugins/PluginRunner';
import CommentUnfurlPreview from 'app/scripts/views/templates/comment-unfurl-preview';
import pluginValidators from 'app/scripts/lib/plugins/plugin-validators';
import { navigate } from 'app/scripts/controller/navigate';
// eslint-disable-next-line no-restricted-imports
import parseURL from 'url-parse';
import { LazyProfileCard } from 'app/src/components/ProfileCard';
const {
  applyBidiTooltip,
} = require('app/src/components/TrelloMarkdown/applyBidiTooltip');
import { BUTLER_POWER_UP_ID } from 'app/scripts/data/butler-id';

const events = {
  'click .js-show-mem-menu': 'viewMemberActionMenu',
  'click .js-open-attachment-viewer': 'openAttachmentViewer',
  'click .js-open-card': 'openCard',
  'click .js-reply-to-action': 'reply',
  'click .js-reply-to-all-action': 'replyAll',
  'click .js-expand-comment': 'expandComment',
  'click .js-app-creator-link': 'onAppCreatorLinkClicked',
  'click a': 'checkAttachment',
};

function __guard__(value, transform) {
  return typeof value !== 'undefined' && value !== null
    ? transform(value)
    : undefined;
}

class ActionView extends View {
  static initClass() {
    this.prototype.className = 'phenom';
    this.prototype.events = events;
  }

  initialize({ context, highlighted, source }) {
    let checklist;
    this.context = context;
    this.highlighted = highlighted;
    this.source = source;
    this.listenTo(this.model, 'takingTooLong change', this.render);
    const data = this.model.get('data');
    if ((data.card != null ? data.card.id : undefined) != null && data.board) {
      let card;
      this.listenTo(
        this.modelCache,
        `remove:Action:${this.model.get('id')}`,
        () => {
          return this.remove();
        },
      );

      if (
        (card = this.model.getCard()) != null &&
        card.id !== this.context.id
      ) {
        this.listenTo(card, 'change:name', this.render);
      }
    }

    if ((checklist = this.model.getChecklist()) != null) {
      this.listenTo(checklist, 'change:name', this.render);
    }

    this.listenTo(
      this.model.reactionList,
      'add remove reset',
      this.renderReactions,
    );
  }

  getData() {
    const entities = new EntityDisplay('action').getEntities(
      this.model.getDisplay(),
      this.context.id,
    );

    return {
      saved: this.model.id != null,
      entities: _.map(entities, this._withEntityInfo.bind(this)),
      date: this.model.get('date'),
      dateLastEdited: this.model.get('data').dateLastEdited,
      textData: this.model.get('data').textData,
      url:
        this.model.getCard() != null
          ? Controller.getActionUrl(this.model)
          : null,
      appCreator: this.model.getAppCreator(),
    };
  }

  getTrackingContext() {
    const { card, list, board } = this.model.get('data');

    const category =
      this.context.typeName === 'Card' ? 'card detail' : 'board sidebar';

    return _.extend(
      {},
      {
        actionId: this.model.id,
        cardId: card != null ? card.id : undefined,
        listId: list != null ? list.id : undefined,
        boardId: board != null ? board.id : undefined,
        orgId: this.model.getBoard()?.getOrganization()?.id,
      },
      { category },
    );
  }

  getContext() {
    const context = {};
    const me = Auth.me();

    const board = this.modelCache.get(
      'Board',
      __guard__(
        __guard__(this.model.get('data'), (x1) => x1.board),
        (x) => x.id,
      ),
    );
    if (this.options.showBoard) {
      if (board != null) {
        context.board = board.toJSON({ prefs: true, url: true });
        context.boardPLevelIconClass = getPermLevelIconClassForBoard(board);
        context.boardPLevelAltText = getPermLevelAltTextForBoard(board);
      }
    }

    if (this.options.showOrganization) {
      const organization = this.modelCache.get(
        'Organization',
        __guard__(
          __guard__(this.model.get('data'), (x3) => x3.organization),
          (x2) => x2.id,
        ),
      );
      if (organization != null) {
        context.organization = organization.toJSON({
          prefs: true,
          url: true,
        });
        context.orgPLevelIconClass = organization.getPermLevel();
        context.orgPLevelAltText = l([
          'org perms',
          organization.getPermLevel(),
          'text',
        ]);
      }
    }

    const memberCreator = this.modelCache.get(
      'Member',
      this.model.get('idMemberCreator'),
    );

    const currentBoard = this.model.getBoard();
    context.isPublicUser =
      currentBoard && currentBoard?.isMemberPublic(Auth.me());
    context.canReply =
      (board != null ? board.canComment(me) : undefined) &&
      (this.model.isAddAttachment() ||
        (this.model.isCommentLike() &&
          memberCreator != null &&
          !Auth.isMe(memberCreator)));
    context.canReplyAll =
      context.canReply &&
      new RegExp(/@([a-z0-9_]+)/).test(this.model.get('data').text);
    context.canDelete = this.model.deletable();
    context.canEdit = this.model.editable();
    context.member = memberCreator != null ? memberCreator.toJSON() : undefined;
    if (context.member != null) {
      context.member.url = Controller.getMemberProfileUrl(context.member.id);
    }
    if (context.member != null) {
      context.member.isDeactivated =
        board != null ? board.isDeactivated(context.member) : undefined;
    }
    context.showReactions =
      this.context.typeName === 'Card' &&
      this.model.get('type') === 'commentCard';
    context.canReact = this.model.canReact();
    context.showInlineReactionButton =
      context.showReactions && !this.model.reactionList.length;
    context.canLinkAppCreator = this.source !== 'memberActivityScreen';

    return context;
  }

  getOptions() {
    let left;
    return {
      showCompactAttachmentPreview: this.options.compact,
      truncateComment:
        (left =
          typeof this.options.truncateComments === 'function'
            ? this.options.truncateComments(this.model)
            : undefined) != null
          ? left
          : false,
      showOptions:
        !this.model.isPlaceholder() &&
        !this.options.compact &&
        !this.options.readOnly,
      useEmbedly: !this.options.compact && this.model.isCommentLike(),
      usePreviews: !this.options.compact && this.model.isAddAttachment(),
      useCommentUnfurl:
        this.options.compact != null &&
        !this.options.compact &&
        this.model.isCommentLike(),
      extremeTruncation: this.options.extremeTruncation,
    };
  }

  render() {
    let board, url;
    const data = this.getData();
    const options = this.getOptions();
    const context = this.getContext();
    const source = this.source;
    const isComment = this.model.isCommentLike();

    const noEntityLength = !data.entities.length;

    this.$el.addClass(
      noEntityLength
        ? 'hide'
        : isComment
        ? 'mod-comment-type'
        : 'mod-attachment-type',
    );

    this.$el.html(actionTemplate(data, context, options));
    applyBidiTooltip(this.el);

    const containers = {
      ...(this.model?.getCard?.()?.getAnalyticsContainers?.() ?? {}),
      ...(this.model?.getBoard?.()?.getAnalyticsContainers?.() ?? {}),
    };

    // Some actions wouldn't have a board associated with them
    if ((board = this.model.getBoard()) != null) {
      $('.js-friendly-links', this.$el).each(function () {
        return friendlyLinks(this, board, {
          analyticsContext: {
            source,
            containers,
            attributes: {
              fromSection: isComment ? 'comment' : 'attachment',
            },
          },
        });
      });

      $('.js-friendly-links-for-link-card', this.$el).each(function () {
        return friendlyLinks(this, board, {
          analyticsContext: {
            source,
            containers,
            attributes: {
              fromSection: isComment ? 'comment' : 'attachment',
            },
          },
        });
      });

      if (options.useCommentUnfurl) {
        $('.js-friendly-links', this.$el).each(() =>
          this.renderCommentPreviews(this, board),
        );
      }
    }

    if (options.useEmbedly) {
      // eslint-disable-next-line @trello/enforce-variable-case
      const $embedly = $('.js-embedly', this.$el);
      // Let's see if there's any embedly stuff to throw on here
      for (const entity of Array.from(data.entities)) {
        if (entity.type === 'comment' && entity.embedly != null) {
          try {
            const object = JSON.parse(entity.embedly);
            for (url in object) {
              // Wistia includes have a security vulnerability, don't use them
              const urlData = object[url];
              if (/wistia/i.test(url)) {
                continue;
              }
              urlData[`type_${urlData.type}`] = true;
              urlData.requireHttps = true;
              $embedly
                .removeClass('hide')
                .append(
                  templates.fill(
                    require('app/scripts/views/templates/embedly'),
                    urlData,
                  ),
                );
            }
          } catch (error) {}
        }
      }
    }

    if (options.usePreviews) {
      const attachments = _.filter(
        data.entities,
        (entity) => entity.type === 'attachment',
      );

      if (!_.isEmpty(attachments)) {
        // eslint-disable-next-line @trello/enforce-variable-case
        const $previews = $('.js-previews', this.$el);
        KnownServices.previewHtml(attachments[0].url, function (err, preview) {
          $previews.empty();
          if (err != null) {
            if (err.login != null) {
              $('<div>')
                .addClass('attachment-extra-info-login')
                .html(err.login)
                .appendTo($previews);

              return $previews.removeClass('hide');
            }
          } else if (preview != null) {
            $('<div>')
              .addClass('attachment-extra-info')
              .html(preview)
              .appendTo($previews);

            return $previews.removeClass('hide');
          }
        });
      }
    }

    Dates.update(this.el);

    this.$el.toggleClass('unsent', !!this.model.isTakingTooLong);
    this.renderHighlighted();
    this.renderReactions();

    return this;
  }

  renderHighlighted() {
    this.$el.toggleClass('mod-highlighted', !!this.highlighted);
    return this;
  }

  renderReactions() {
    const context = this.getContext();

    if ((this.reactRoot = this.el.querySelector('.js-reaction-piles'))) {
      return ReactDOM.render(
        <ReactionPiles
          actionId={this.model.id}
          reactionList={this.model.reactionList}
          canReact={context.canReact}
          trackingContext={this.getTrackingContext()}
        />,
        this.reactRoot,
      );
    }
  }

  renderCommentPreviews(els, board) {
    const urls = _.flatten(
      $('.js-friendly-links', this.$el)
        .toArray()
        .map(function (el) {
          if ((el.tagName != null) === 'A') {
            return [el];
          } else {
            return _.toArray(el.querySelectorAll('a'));
          }
        }),
    )
      .map((a) => a.href)
      .filter((url) => url != null);

    return Promise.map(urls, (url) =>
      Promise.try(() => {
        const formatRequest = pluginRunner.one({
          command: 'format-url',
          board,
          options: {
            url,
          },
        });
        return formatRequest;
      })
        .then(function (response) {
          if (response != null) {
            return _.extend(response, { url });
          } else {
            return null;
          }
        })
        .catch(pluginRunner.Error.NotHandled, () => null),
    ).then((formattedUrls) => {
      if (formattedUrls != null && formattedUrls.length > 0) {
        const subviews = formattedUrls
          .filter(pluginValidators.isValidUrlUnfurl)
          .map((data) => {
            if (
              __guard__(
                data != null ? data.actions : undefined,
                (x) => x.length,
              ) > 2
            ) {
              data.actions = data.actions.slice(0, 2);
            }
            return this.subview(
              CommentUnfurlPreview,
              this.model,
              { commentUnfurl: data },
              data.url,
            );
          });
        // eslint-disable-next-line @trello/enforce-variable-case
        const $commentPreview = $('.comment-preview', this.$el);
        this.ensureSubviews(subviews, $commentPreview);
        return $commentPreview.show();
      }
    });
  }

  remove() {
    if (this.reactRoot) {
      ReactDOM.unmountComponentAtNode(this.reactRoot);
    }
    return super.remove(...arguments);
  }

  // TrelloFlavoredMarkdown opts for this action entity
  _tfmFormatOpts() {
    ({
      card: this.model.get('data').card,
      board: this.model.get('data').board,
    });
    siteDomain;
    return { textData: this.model.get('data').textData };
  }

  // Add additional info to an entity for rendering
  _withEntityInfo(entityIn) {
    let card, checklist;
    const entity = _.clone(entityIn);

    if (entity.type === 'attachment') {
      entity.url = this.model.get('data').attachment?.url;

      // Handle friendly deleted link
      if (!entity.url && entity.isFriendly) {
        entity.url = entity.text;
      }
    }

    if (entity.type === 'attachmentPreview') {
      // Set preview URL to use for the browser's DPI
      // The entity has preview URLs already, but those don't always do the right thing with EXIF rotation
      let attachment, left, left1;
      entity.previewUrlForRes =
        (card = ModelCache.get(
          'Card',
          __guard__(this.model.get('data').card, (x) => x.id),
        )) != null &&
        (attachment = card.attachmentList.get(
          __guard__(this.model.get('data').attachment, (x1) => x1.id),
        ))
          ? isHighDPI()
            ? __guard__(
                (left = attachment.smallestPreviewBiggerThan(1000)) != null
                  ? left
                  : attachment.biggestPreview(),
                (x2) => x2.url,
              )
            : __guard__(
                (left1 = attachment.smallestPreviewBiggerThan(500)) != null
                  ? left1
                  : attachment.biggestPreview(),
                (x3) => x3.url,
              )
          : undefined;

      if (entity.previewUrlForRes == null) {
        entity.previewUrlForRes =
          isHighDPI() && entity.previewUrl2x != null
            ? entity.previewUrl2x
            : entity.previewUrl;
      }
    }

    if (entity.type === 'comment') {
      const wrapper = document.createElement('div');
      wrapper.innerHTML = TFM.comments.format(
        entity.text,
        this._tfmFormatOpts(),
      ).output;
      TFM.addLineNumbers(wrapper);
      entity.textHtml = wrapper.innerHTML;
    }

    if (entity.type === 'checkItem') {
      entity.nameHtml = TFM.checkItems.format(
        entity.text,
        this._tfmFormatOpts(),
      ).output;
    }

    if (entity.type === 'date') {
      entity.text = moment(entity.date).calendar();
    }

    // Use the most recent name for the card, if available
    if (
      entity.type === 'card' &&
      (card = ModelCache.get('Card', entity.id)) != null
    ) {
      if (card.get('cardRole') === 'link') {
        entity.nameHtml = TFM.name.format(
          card.get('name'),
          this._tfmFormatOpts(),
        ).output;
      } else {
        entity.text = card.get('name');
      }
    }

    if (
      entity.type === 'checklist' &&
      (checklist = ModelCache.get('Checklist', entity.id)) != null
    ) {
      entity.text = checklist.get('name');
    }

    return entity;
  }

  viewMemberActionMenu(e) {
    let left;
    stopPropagationAndPreventDefault(e);

    const member = this.modelCache.get(
      'Member',
      (left = $(e.target).closest('[idmember]').attr('idmember')) != null
        ? left
        : this.model.get('idMemberCreator'),
    );

    PopOver.toggle({
      elem: $(e.target, this.$el).closest('.js-show-mem-menu'),
      reactElement: (
        <LazyProfileCard
          key="profile"
          // eslint-disable-next-line react/jsx-no-bind
          onClose={() => PopOver.hide()}
          memberId={member.id}
        />
      ),
      hideHeader: true,
    });
  }

  expandComment(e) {
    stopPropagationAndPreventDefault(e);
    return $('.js-comment', this.$el).removeClass('is-truncated');
  }

  openCard(e) {
    let url;
    if (this.context.typeName === 'Card' || $(e.target).is('a,textarea')) {
      // Let the browser do the normal thing, e.g. open the link or edit
      return;
    }

    // If they've just selected some text, they aren't trying to open the card
    if (hasSelection()) {
      return;
    }

    stopPropagationAndPreventDefault(e);
    // Navigate to the action URL
    if ((url = Controller.getActionUrl(this.model)) != null) {
      navigate(url, { trigger: true });
    }
  }

  openAttachmentViewer(e) {
    if (e.metaKey || e.ctrlKey) {
      return;
    }

    // eslint-disable-next-line @trello/enforce-variable-case
    const $target = $(e.target);
    if ($target.closest('.window-main-col').length > 0) {
      stopPropagationAndPreventDefault(e);
      if (!AttachmentViewer.isActive()) {
        const idAttachment = $target
          .closest('.js-open-attachment-viewer')
          .attr('data-idattachment');
        AttachmentViewer.show({
          model: this.model.getCard(),
          idAttachment,
        });
      }
    }
  }

  reply(e) {
    stopPropagationAndPreventDefault(e);
    this.$el.trigger('replyToAction', this.model);
    const {
      actionId,
      cardId,
      listId,
      boardId,
      orgId,
      category,
    } = this.getTrackingContext();
    return Analytics.sendClickedButtonEvent({
      buttonName: 'replyButton',
      source: this.source,
      containers: {
        card: {
          id: cardId,
        },
        board: {
          id: boardId,
        },
        list: {
          id: listId,
        },
        organization: {
          id: orgId,
        },
      },
      attributes: {
        actionId,
        actionType: this.model.get('type'),
        category,
        replyType: 'reply to comment',
      },
    });
  }

  replyAll(e) {
    stopPropagationAndPreventDefault(e);
    this.$el.trigger('replyToAllAction', this.model);
    const {
      actionId,
      cardId,
      listId,
      boardId,
      orgId,
      category,
    } = this.getTrackingContext();
    return Analytics.sendClickedButtonEvent({
      buttonName: 'replyButton',
      source: this.source,
      containers: {
        card: {
          id: cardId,
        },
        board: {
          id: boardId,
        },
        list: {
          id: listId,
        },
        organization: {
          id: orgId,
        },
      },
      attributes: {
        actionId,
        actionType: this.model.get('type'),
        category,
        replyType: 'reply to all comment',
      },
    });
  }

  setHighlighted(highlighted) {
    if (highlighted !== this.highlighted) {
      this.highlighted = highlighted;
      this.renderHighlighted();
    }
  }

  checkAttachment(e) {
    if (e.metaKey || e.ctrlKey) {
      return;
    }

    const card = this.model.getCard();
    const { href } = e.currentTarget;
    const hrefPath = parseURL(href).pathname;
    const attachment = card?.attachmentList?.find(
      (att) => parseURL(att.get('url')).pathname === hrefPath,
    );
    if (attachment && AttachmentHelpers.isViewerable(attachment.get('url'))) {
      e.preventDefault();

      return AttachmentViewer.show({
        model: card,
        idAttachment: attachment.id,
      });
    }
  }

  onAppCreatorLinkClicked(e) {
    stopPropagationAndPreventDefault(e);
    const board = this.model.getBoard();
    if (!board) {
      return;
    }
    const appCreator = this.model.getAppCreator();

    if (appCreator?.idPlugin) {
      const idMe = Auth.myId();
      if (
        (board.get('memberships') || []).some(
          ({ idMember }) => idMember === idMe,
        )
      ) {
        if (appCreator.idPlugin === BUTLER_POWER_UP_ID) {
          Controller.getCurrentBoardView().toggleButlerView(board.id);
        } else {
          // Member is a board member, so can run a plugin
          pluginRunner.one({
            plugin: appCreator.idPlugin,
            command: 'show-settings',
            board,
            el: e.currentTarget,
          });
        }
      } else {
        // Member is not a board member, take them to the plugin listing
        window.open('/power-ups/' + appCreator.idPlugin);
      }
    }

    const {
      actionId,
      cardId,
      listId,
      boardId,
      orgId,
    } = this.getTrackingContext();

    Analytics.sendClickedLinkEvent({
      linkName: 'appCreatorLink',
      source: this.source,
      attributes: {
        appCreatorId: appCreator?.id,
        appCreatorIdPlugin: appCreator?.idPlugin,
        actionType: this.model.get('type'),
        actionId,
      },
      containers: {
        card: {
          id: cardId,
        },
        board: {
          id: boardId,
        },
        list: {
          id: listId,
        },
        organization: {
          id: orgId,
        },
      },
    });
  }
}

ActionView.initClass();

export { events, ActionView };
